import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { VContainer, VRow, VCol, VCard, VAlert, VBtn, VSnackbar } from "vuetify/lib";
import { ICONS, BeosIcon, BeosInput } from "@begentoOS/begento-ui";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosIconCatalog',
    setup(__props) {
        const search = ref('');
        const snackbar = ref(false);
        const iconEntries = Object.keys(ICONS).map(key => [key, ICONS[key]]);
        const filteredIcons = computed(() => {
            if (!search.value)
                return iconEntries;
            const query = search.value.toLowerCase();
            return iconEntries.filter(([name, value]) => name.toLowerCase().includes(query) ||
                String(value).toLowerCase().includes(query));
        });
        const copyToClipboard = (text) => {
            navigator.clipboard.writeText(text).then(() => {
                snackbar.value = true;
            });
        };
        return { __sfc: true, search, snackbar, iconEntries, filteredIcons, copyToClipboard, VContainer, VRow, VCol, VCard, VAlert, VBtn, VSnackbar, BeosIcon, BeosInput };
    }
});
